<template>
    <v-dialog v-model="show" max-width="760">
        <v-card v-if="order" class="v-card--dialog v-card--dialog--sm">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">발행내역</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body">
                <v-data-table :items="order.issues" :headers="issuesHeaders">
                    <template slot="item.no" slot-scope="{item}">{{ order.issues.indexOf(item) + 1 }}</template>
                </v-data-table>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import api from "@/api";
export default {
    data(){
        return {
            show: false,

            order: null,
            issuesHeaders: [
                { text: "No", value: "no", align: "left", width: "14%" },
                { text: "발권주문번호", value: "ino", align: "left" },
                { text: "상태", value: "status", align: "left" },
                { text: "관리자 내용", value: "note", align: "left" },
            ]
        }
    },
    methods: {
        async open(){
            let { order } = await api.v1.me.gshop.orders.get({ _id: this.order._id });
            this.order = order;

            this.show = true;
        },
        close(){
            this.show = false;
            this.order = null;
        }
    }
}
</script>